import React from 'react'

const LoadingCarpet = () => {
  return (
    <div className='w-100 h-100 d-flex position-absolute top-0 start-0 bg-light text-center'>
        <img src='../assets/images/loading-carpet.svg' alt='loading' className='m-auto'/>
    </div>
  )
}

export default LoadingCarpet